<template>
    <div>
        <b-row class=" m-0 pt-0 pb-0  mt-0">
            <b-col class="w-100 pb-0 m-0 mt-0 pt-0 pb-0" md="12">
                <p v-if="this.info">
                    <small v-html="this.info"></small>
                </p> 
                <label class="form-control-label">{{ metadata.xfields.title }}</label>
                <b-form>
                    <b-form-select v-if="metadata.xfields.options" v-model="metadata.xfields.value"
                        :options="metadata.xfields.options"></b-form-select>
                    <!-- <base-input v-if="metadata.xfields.options" :label="metadata.xfields.title">
                    </base-input> -->
                    <base-input :label="'Detalhes'">
                        <b-textarea v-model="metadata.xfields.message" placeholder="deixe sua mensagem..."></b-textarea>
                    </base-input>
                    <base-button type="primary" native-type="submit" class="my-1"
                        @click="saveMetadata(); return false;">Salvar</base-button>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import store from '@/store'
import cakeService from '@/services/cakephp'
import swal from "sweetalert2";

export default {
    props: {
        metadataType: {
            type: String,
            default: 'DefaultMetadata'
        },
        xfields: {
            type: Object,
            default: {
                type: 'DefaultMetadata',
                history:[],
                date:(new Date()).toISOString(),
                user:{},
                title:'',
                value:'new',
                message:'',
            }
        },
        bill_id: {
            type: Number,
            default: 0
        },
        uuid: {
            type: String,
            default: ''
        },
        uuid_ref: {
            type: String,
            default: ''
        },
        hash:{
            type: String,
            default: ''
        },
        /** html msg show above metadata form to guide the user */
        info: {
            type: String,
            default: ''
        },
        /** form title */
        title: {
            type: String,
            default: 'Edição de metadado'
        },
        keepHistory: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            name: 'MetadataModal',
            metadata: {},
            serviceStatus:{
                //andamento (primary) [amarelo], concluído (done)[azul], pendente ()[vermelho], finalizado (done + checked)[verde]
                options: { new: 'Novo', doing: 'Em andamento', done: 'Concluído', finished: 'Finalizado', analises: 'com pendências' },
                default: 'new'
            }
        }
    },
    created() {
        this.metadata.uuid = this.uuid || ''
        this.metadata.bill_id = this.bill_id || 0
        this.metadata.uuid_ref = this.uuid_ref || ''
        this.metadata.xfields = this.xfields || {}

        if (!this.metadata.xfields.type) {
            this.metadata.xfields.type = this.metadataType || 'DefaultMetadata'
        }

        if (!this.metadata.xfields.history) {
            this.metadata.xfields.history = []
        }

        if (!this.metadata.xfields.date) {
            this.metadata.xfields.date = new Date().toISOString()
        }
        
        if (!this.metadata.xfields.title) {
            this.metadata.xfields.title = this.title || ''
        }    
        
        if (!this.metadata.xfields.value) {
            this.metadata.xfields.value = 'new'
        }    
        
        if (!this.metadata.xfields.message) {
            this.metadata.xfields.message = ''
        }    
        
        this.metadata.xfields.user = {}
        this.metadata.xfields.user.name = store.state.auth.user.name
        this.metadata.xfields.user.uuid = store.state.auth.user.uuid
        
        switch (this.metadataType) {
            case 'ServiceStatus':
                this.metadata.xfields.type = 'ServiceStatus'                
                if (!this.metadata.xfields.options) {
                    this.metadata.xfields.options = this.serviceStatus.options
                }    
                if (!this.metadata.xfields.value) {
                    this.metadata.xfields.value = this.serviceStatus.default
                }                
                break;

            default:
                break;
        }
    },
    methods: {
        saveMetadata() {
            if (this.keepHistory) {
                let snapshot = JSON.parse(JSON.stringify(this.metadata.xfields))
                delete snapshot.type
                delete snapshot.history
                delete snapshot.title
                delete snapshot.options
                this.metadata.xfields.history.push(snapshot)
            }
            cakeService.createUpdateMetadata(this.metadata, this.hash).then(response => {
                swal.fire({
                    text: 'atualizado com sucesso!',
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success",
                    icon: 'success',
                }).then((result) => {
                    if(result.value){
                        swal.close()
                        let tmp = JSON.parse(response)
                        this.$emit('close-modal',tmp.create_hashcode || tmp.update_hashcode)
                    }
                })
            }).fail(function(err) {
                swal.fire({
                    text: err.message,
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success",
                    icon: 'error',
                }).then((result) => {
                    swal.close()
                    let tmp = JSON.parse(response)
                    this.$emit('close-modal',tmp.create_hashcode)
                })
            })
        }
    }
}
</script>